<template>
  <section class="search-list">
    <div class="header">
      <div class="content">
        <div class="text-container">
          <slot name="header" />
        </div>
      </div>
    </div>
    <div class="padding-container">
      <div class="content">
        <slot name="default" />
      </div>
    </div>
  </section>
</template>

<style scoped>
  .search-list {
    max-width: var(--screen-sizes-desktop-width);
    min-height: var(--screen-sizes-desktop-height-minimum);
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header {
    display: flex;
    padding: 0 var(--layout-side-padding-desktop);
    flex-direction: column;
    align-items: center;
    align-self: stretch;
  }

  .content {
    display: flex;
    max-width: var(--layout-12-col-grid-max);
    padding-top: var(--spacing-m);
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-m);
    align-self: stretch;
    margin: 0 auto;
  }

  .text-container {
    display: flex;
    max-width: var(--layout-8-col-text-max);
    width: var(--layout-8-col-text-max);
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    margin: 0 auto;
  }
</style>
